import Modal from '../../ui/modal/modal'
import Flex from '../../ui/flex/flex'
import Grid from '../../ui/grid/grid'
import Button from '../../ui/button/button'
import { IModalSMS } from './modalSMS.type'
import Input from '../../ui/input/input'
import Divider from '../../ui/divider/divider'


const ModalSMS = ({
    isOpen, timerValue, disabledRepeatBtn, txtNum,
    handlerButtonOk, handlerButtonCancel, handlerButtonRepeat
}: IModalSMS) => {
    return <Modal isOpen={isOpen}>
        <Flex className='modal_container'>
            <Flex className='modal_container-header'>
                <h4>Подтверждение телефона...</h4>
            </Flex>

            <Flex gap='4px' className='modal_container-body'>
                <Flex className='modal_container-content' alignItems='center'>
                    <Grid gap='10px' gridTemplate='columns' gridTemplateColumns='200px'>
                        <Input size='lg' type='mask' textAlign='center' mask='9999' maskChar='—' value={txtNum.value} onChange={(e) => txtNum.setValue(e.target.value)} />
                    </Grid>
                </Flex>

                <Button variant='iconBr' isDisabled={disabledRepeatBtn.value} onClick={handlerButtonRepeat}>
                    {disabledRepeatBtn.value ? `Отправить повторно через ${timerValue.value}` : 'Отправить повторно'}
                </Button>

                <Divider />

                <Grid gap='6px' gridTemplate='columns' gridTemplateColumns='1fr 1fr'>
                    <Button variant='primaryDark' width='100%' onClick={handlerButtonCancel}>ОТМЕНА</Button>
                    <Button width='100%' onClick={() => handlerButtonOk && handlerButtonOk(Number(txtNum.value))}>ПОДТВЕРДИТЬ</Button>
                </Grid>
            </Flex>
        </Flex>
    </Modal>
}

export default ModalSMS